<div class="zone-wrapper">
    <iframe *ngIf="!errorMessage && iframeUrl" class="zone-iframe" width="100%" height="100%" frameBorder="0"
        [src]="iframeUrl | safe" [class.zone-iframe--interactive]="isGridLocked">
    </iframe>
    <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
</div>